// extracted by mini-css-extract-plugin
export var avatarContainer = "_48-1";
export var largeAvatarContainer = "_48-2";
export var smallAvatarContainer = "_48-0";